var render = function render(_c, _vm) {
  return _c(
    "div",
    { staticClass: "mx-3" },
    _vm._l(_vm.props.visits, function(item, index) {
      return _c("div", { key: `visit-item-${index}`, staticClass: "mb-3" }, [
        _c("div", { staticClass: "rounded bg-secondary-3 p-3 px-4" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-2" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Fecha: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [_vm._v(" " + _vm._s(_vm._f("date")(item.visitDate)) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Horario: ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [_vm._v(" " + _vm._s(item.completeTimeLower) + " ")]
              )
            ]),
            _c("div", { staticClass: "col-md-2" }, [
              _c(
                "span",
                { staticClass: "font-14 font-weight-normal color-secondary-6" },
                [_vm._v(" Tipo: ")]
              ),
              _c("p", { staticClass: "font-16 font-weight-bold color-black" }, [
                _vm._v(" " + _vm._s(item.visitTypeName) + " ")
              ])
            ]),
            _c("div", { staticClass: "col-md-3" }, [
              item.justification
                ? _c(
                    "span",
                    {
                      staticClass:
                        "font-16 font-weight-normal color-secondary-6"
                    },
                    [_vm._v(" Justificación: ")]
                  )
                : _vm._e(),
              item.justification
                ? _c(
                    "p",
                    { staticClass: "font-16 font-weight-normal color-black" },
                    [_vm._v(" " + _vm._s(item.justification) + " ")]
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-md-2" }, [
              _c(
                "span",
                {
                  staticClass:
                    "font-14 font-weight-normal color-secondary-6 pr-1"
                },
                [_vm._v(" P/I ")]
              ),
              _c(
                "p",
                { staticClass: "font-16 font-weight-normal color-black" },
                [
                  _vm._v(
                    " " +
                      _vm._s(item.hasPractitionerOrInternal ? "Si" : "No") +
                      " "
                  )
                ]
              )
            ])
          ]),
          item.comment
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("hr", { staticClass: "mt-n1" }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "font-16 font-weight-normal color-secondary-6"
                    },
                    [_vm._v(" Comentario: ")]
                  ),
                  _c(
                    "p",
                    { staticClass: "font-12 font-weight-normal color-black" },
                    [_vm._v(" " + _vm._s(item.comment) + " ")]
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }